import type { Problem } from './problems';

// Full-field skeleton for the admin "New problem" flow. Authoring a new problem
// starts from this so it lands in exactly the bundled on-disk format (the same
// shape the seed/loader and the Pyodide/JS harness expect). It defaults to an
// `algorithm` problem — by far the most common type; an author can change `type`
// and adjust the body in the raw editor for class / fullstack / agent / react.
//
// The placeholder ids/titles are deliberately obvious so a half-finished problem
// is easy to spot. Backend validation requires id, realmId, skillId, title,
// difficulty, type, description — all present here.
export function newProblemTemplate(): Problem {
  return {
    id: 'new-problem-id',
    realmId: 'algo',
    skillId: 'two',
    type: 'algorithm',
    title: 'New problem title',
    difficulty: 'Easy',
    summary: 'One-sentence summary shown in search + lists.',
    source: 'original',
    estTimeMin: 15,
    tags: [],
    description:
      'Describe the task in Markdown. State the function contract, constraints, '
      + 'and target complexity. Rephrase on the 4 axes (story, variables, function '
      + 'names, example data) so it is not a copy of a known problem.',
    examples: [
      { input: 'arg = "example"', output: 'true', explanation: 'Why this output.' },
    ],
    hints: [
      { text: 'First nudge toward the approach.' },
      { text: 'A more concrete step.' },
    ],
    pyStarter: 'def solve(arg):\n    # your code here\n    pass\n',
    jsStarter:
      '/**\n * @param {string} arg\n * @return {boolean}\n */\n'
      + 'var solve = function(arg) {\n\n};',
    testCases: [
      { input: { arg: 'example' }, expected: true },
    ],
    referenceSolution: {
      python: 'def solve(arg):\n    # reference implementation\n    return True\n',
    },
  } as unknown as Problem;
}
